var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFileDownHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_16598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.75V17.25C19.5 18.49 18.49 19.5 17.25 19.5H6.75C5.51 19.5 4.5 18.49 4.5 17.25V15.75C4.5 15.34 4.16 15 3.75 15C3.34 15 3 15.34 3 15.75V17.25C3 19.32 4.68 21 6.75 21H17.25C19.32 21 21 19.32 21 17.25V15.75C21 15.34 20.66 15 20.25 15C19.84 15 19.5 15.34 19.5 15.75Z",
    fill: "#0076ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2497 3.75L11.2697 15.58C11.1497 15.51 11.0397 15.43 10.9397 15.34L8.02967 12.43C7.73967 12.13 7.26967 12.12 6.96967 12.41C6.66967 12.7 6.65967 13.17 6.94967 13.47C6.94967 13.47 6.95967 13.48 6.96967 13.49L9.87967 16.4C11.0497 17.57 12.9497 17.57 14.1197 16.4L17.0297 13.49C17.3297 13.2 17.3397 12.73 17.0497 12.43C16.7597 12.13 16.2897 12.12 15.9897 12.41C15.9897 12.41 15.9797 12.42 15.9697 12.43L13.0597 15.34C12.9697 15.42 12.8797 15.5 12.7697 15.56L12.7497 3.75C12.7497 3.34 12.4097 3 11.9997 3C11.5897 3 11.2497 3.34 11.2497 3.75Z",
    fill: "#0076ff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_16598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileDownHover);
export default __webpack_public_path__ + "static/media/ico-file-down-hover.1535e731b7151998bd31cabbf00193a6.svg";
export { ForwardRef as ReactComponent };